import { SB } from '@play-co/replicant';

export const leaguesSchema = {
  leagues: SB.map(
    SB.object({
      score: SB.int(),
      phase: SB.int().default(1),
      tier: SB.string().default('master'),
      finalTier: SB.string().optional(),
      finalRank: SB.int().optional(),
      claimed: SB.boolean(),
      modifiedAt: SB.int(),
      createdAt: SB.int(),
      restored: SB.boolean().optional(),
      /** @deprecated A/B 0483 resolved to Enabled; kept for state compatibility. */
      mastersLeagueDifficultyBucket: SB.string().optional(),
    }),
  ),
  /** All time score  */
  leaguesAllTimeScore: SB.int(),
  /**
   * Position in `leaguePhase2Allowlist`, advanced once per league win. Unlike
   * the per-league score it persists across league cycles, so a
   * `match2MaxLevel` bump continues the curated list instead of restarting it.
   *
   * Non-negative: the allow-list is indexed with a plain modulo, which would
   * yield a negative index — and so an undefined level — for a negative
   * cursor.
   */
  leaguePhaseCursor: SB.int().min(0),
};
